import { createContext, useState } from 'react';

const UsersContext = createContext()

export const useUsersContext = () => {
	const [editUser, setEditUser] = useState(undefined)
	
	const handleSetEditUser = (user=undefined) => {
		setEditUser(user)
	}
	return {
		editUser,
		setEditUser: handleSetEditUser 
	}
}

export default UsersContext
